/* Canonical buyer attribution for cart purchases and accepted-offer drafts. */
(function () {
  'use strict';
  var CLICK_KEY = 'mnb_purchase_google_click';
  var fetchCart = window.fetch.bind(window);
  var syncing = Promise.resolve();
  function consent(value) {
    return value === 'granted' || value === 'yes' ? 'granted' : value === 'denied' || value === 'no' ? 'denied' : 'unknown';
  }
  function observedConsent() {
    var explicit = window.mnbObservedGoogleConsent;
    if (explicit) return {adUserData:consent(explicit.ad_user_data),adPersonalization:consent(explicit.ad_personalization),adStorage:consent(explicit.ad_storage)};
    var state = {};
    try { state = window.Shopify.customerPrivacy.currentVisitorConsent(); } catch (_) { /* unavailable means unknown */ }
    var marketing = consent(state.marketing);
    // A data-sharing opt-out overrides marketing permission. Do not infer a
    // grant from processingAllowed(), which can reflect regional defaults.
    if (consent(state.sale_of_data) === 'denied') marketing = 'denied';
    // custom.js derives ad_storage from the same marketing choice.
    return {adUserData:marketing,adPersonalization:marketing,adStorage:marketing};
  }
  function googleClick() {
    var params = new URLSearchParams(window.location.search);
    var stored = null;
    try { stored = JSON.parse(window.localStorage.getItem(CLICK_KEY)); } catch (_) {}
    for (var type of ['gclid','gbraid','wbraid']) {
      var id = params.get(type);
      if (id && id.length <= 2048) {
        if (!stored || stored.id !== id || stored.type !== type) {
          stored = {id:id,type:type,capturedAt:new Date().toISOString()};
          try { window.localStorage.setItem(CLICK_KEY,JSON.stringify(stored)); } catch (_) {}
        }
        return stored;
      }
    }
    return stored && ['gclid','gbraid','wbraid'].includes(stored.type) && typeof stored.id === 'string' ? stored : null;
  }
  function capturedClientId() {
    var cookie = /(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)(?:;|$)/.exec(document.cookie);
    return cookie ? cookie[1] : window.mnbGtagIds && window.mnbGtagIds.clientId || '';
  }
  window.mnbCapturePurchaseTracking = async function () {
    var click = googleClick();
    var observed = observedConsent();
    var client = capturedClientId();
    return {
      tracking_client_id:client,
      tracking_client_id_source:client ? 'captured' : 'missing',
      tracking_session_id:window.mnbGtagIds && window.mnbGtagIds.sessionId || '',
      tracking_google_click_id:click ? click.id : '',
      tracking_google_click_id_type:click ? click.type : '',
      tracking_google_click_captured_at:click ? click.capturedAt : '',
      tracking_ad_user_data:observed.adUserData,
      tracking_ad_personalization:observed.adPersonalization,
      tracking_captured_at:new Date().toISOString()
    };
  };
  window.mnbSyncPurchaseCart = function () {
    syncing = syncing.catch(function () {}).then(async function () {
      var snapshot = await window.mnbCapturePurchaseTracking();
      var attributes = {
        __mnb_ga_client_id:snapshot.tracking_client_id,
        __mnb_ga_session_id:snapshot.tracking_session_id,
        __mnb_google_click_id:snapshot.tracking_google_click_id,
        __mnb_google_click_id_type:snapshot.tracking_google_click_id_type,
        __mnb_google_click_captured_at:snapshot.tracking_google_click_captured_at,
        __mnb_ad_user_data:snapshot.tracking_ad_user_data,
        __mnb_ad_personalization:snapshot.tracking_ad_personalization,
        __mnb_tracking_captured_at:snapshot.tracking_captured_at
      };
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      var response = await fetchCart(root + 'cart/update.json',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attributes})});
      if (!response.ok) throw new Error('purchase_cart_snapshot_failed');
    });
    return syncing;
  };
  // Read-only views for diagnostics elsewhere (new-listing.js ads_signup_*):
  // the same consent reading, and whether a click id is held — never the id.
  window.mnbObservedConsent = observedConsent;
  window.mnbHasGoogleClick = function () { return !!googleClick(); };
  googleClick();
  document.addEventListener('visitorConsentCollected',function () { return window.mnbSyncPurchaseCart().catch(function () {}); });
  // Wait for attributes before ordinary checkout navigation. Hosted accelerated
  // checkout still needs live transfer verification in Shopify.
  document.addEventListener('click',function (event) {
    var target = event.target.closest && event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!target || target.dataset.mnbPurchaseReady === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    window.mnbSyncPurchaseCart().then(function () { target.dataset.mnbPurchaseReady='true'; target.click(); delete target.dataset.mnbPurchaseReady; }).catch(function () { target.dataset.mnbPurchaseReady='true'; target.click(); delete target.dataset.mnbPurchaseReady; });
  },true);
  document.addEventListener('submit',function (event) {
    var form = event.target;
    if (form.dataset.mnbPurchaseReady === 'true' || !(event.submitter && event.submitter.name === 'checkout')) return;
    event.preventDefault();
    var submitter=event.submitter;
    function resume() { form.dataset.mnbPurchaseReady='true'; form.requestSubmit(submitter); delete form.dataset.mnbPurchaseReady; }
    window.mnbSyncPurchaseCart().then(resume,resume);
  },true);
  document.addEventListener('DOMContentLoaded',function () { window.mnbSyncPurchaseCart().catch(function () {}); });
})();
